module.exports = __webpack_public_path__ + "components/flag/static/square/ki-2c92f98e50375b26b0f07a7977868842.svg";